export type Lang = "pt" | "es";

export const translations = {
  pt: {
    // Header
    appName: "CONTERA",
    appSubtitle: "Comparador CCTV IP",
    tabCatalog: "Catálogo",
    tabCompare: "Comparar Modelo",
    searchPlaceholder: "Pesquisar modelo...",

    // Filter Panel
    filters: "Filtros",
    filterActive: "ativo",
    brand: "Marca",
    brandAll: "Todas",
    megapixels: "Megapixels",
    type: "Tipo",
    lensType: "Tipo de Lente",
    lensAll: "Todas",
    lensFixed: "Fixa",
    lensMotorized: "Motorizada",
    irMin: "Alcance IR mínimo",
    irAll: "Todos",
    wdr: "WDR",
    wdrAll: "Todos",
    intelligentDetection: "Deteção Inteligente",
    detPeople: "Deteção de Pessoas",
    detPeopleVehicle: "Deteção de Pessoas e Viaturas",
    triStateLegend: "— qualquer · ✓ com · ✗ sem",
    features: "Funcionalidades",
    sortBy: "Ordenar por",
    sortModel: "Modelo",
    sortMp: "MP ↓",
    sortIr: "IR ↓",
    sortPrice: "Preço",
    sortBrand: "Marca",
    clearFilters: "Limpar filtros",

    lpr: "LPR",

    // Camera Card
    audio: "Áudio",
    viewProduct: "Ver produto na Contera",

    // Catalog page
    cameras: "câmaras",
    noResults: "Nenhuma câmara encontrada",
    noResultsHint: "Tente ajustar os filtros",

    // Compare page
    compareTitle: "Comparar por Modelo",
    compareSubtitle: "Escreve parte de uma referência DAHUA ou TVT e seleciona o modelo para ver o equivalente",
    modelToSearch: "Modelo a pesquisar",
    modelHint: "Escreve parte da referência (ex: \"HFW2441\", \"9442\", \"VDTV\") e seleciona da lista",
    comparePlaceholder: "Ex: HFW2441, 9442S4L, IPC-HDW...",
    compareBtn: "Comparar",
    results: "resultado",
    resultsPlural: "resultados",
    selected: "Selecionado:",
    clickToCompare: "Clica \"Comparar\" para ver equivalente →",
    selectedCamera: "Câmara selecionada",
    equivalent: "Equivalente",
    similarModels: "Modelos similares",
    noEquivalent: "Não foi encontrado equivalente mapeado para este modelo.",
    contactCommercial: "Contacte o comercial Contera para mais informações.",
    dahuaCameras: "Câmaras DAHUA",
    tvtCameras: "Câmaras TVT",
    totalCatalog: "Total catálogo",
    howToUse: "Como usar",
    step1: "Escreve parte da referência no campo acima (mínimo 2 caracteres)",
    step2: "Seleciona o modelo correto da lista de sugestões",
    step3: "Clica em",
    step3b: "para ver o equivalente da outra marca",
    catalogTip: "Também podes usar o",
    catalogTipLink: "Catálogo",
    catalogTipEnd: "para filtrar e comparar câmaras lado a lado",

    // Footer
    footer: "© 2026 Contera — Comparador CCTV IP · DAHUA vs TVT",
    footerPrices: "Preços indicativos s/IVA · Contacto:",
  },

  es: {
    // Header
    appName: "CONTERA",
    appSubtitle: "Comparador CCTV IP",
    tabCatalog: "Catálogo",
    tabCompare: "Comparar Modelo",
    searchPlaceholder: "Buscar modelo...",

    // Filter Panel
    filters: "Filtros",
    filterActive: "activo",
    brand: "Marca",
    brandAll: "Todas",
    megapixels: "Megapíxeles",
    type: "Tipo",
    lensType: "Tipo de Lente",
    lensAll: "Todas",
    lensFixed: "Fija",
    lensMotorized: "Motorizada",
    irMin: "Alcance IR mínimo",
    irAll: "Todos",
    wdr: "WDR",
    wdrAll: "Todos",
    intelligentDetection: "Detección Inteligente",
    detPeople: "Detección de Personas",
    detPeopleVehicle: "Detección de Personas y Vehículos",
    triStateLegend: "— cualquiera · ✓ con · ✗ sin",
    features: "Funcionalidades",
    sortBy: "Ordenar por",
    sortModel: "Modelo",
    sortMp: "MP ↓",
    sortIr: "IR ↓",
    sortPrice: "Precio",
    sortBrand: "Marca",
    clearFilters: "Limpiar filtros",

    lpr: "LPR",

    // Camera Card
    audio: "Audio",
    viewProduct: "Ver producto en Contera",

    // Catalog page
    cameras: "cámaras",
    noResults: "Ninguna cámara encontrada",
    noResultsHint: "Intenta ajustar los filtros",

    // Compare page
    compareTitle: "Comparar por Modelo",
    compareSubtitle: "Escribe parte de una referencia DAHUA o TVT y selecciona el modelo para ver el equivalente",
    modelToSearch: "Modelo a buscar",
    modelHint: "Escribe parte de la referencia (ej: \"HFW2441\", \"9442\", \"VDTV\") y selecciona de la lista",
    comparePlaceholder: "Ej: HFW2441, 9442S4L, IPC-HDW...",
    compareBtn: "Comparar",
    results: "resultado",
    resultsPlural: "resultados",
    selected: "Seleccionado:",
    clickToCompare: "Haz clic en \"Comparar\" para ver equivalente →",
    selectedCamera: "Cámara seleccionada",
    equivalent: "Equivalente",
    similarModels: "Modelos similares",
    noEquivalent: "No se encontró equivalente mapeado para este modelo.",
    contactCommercial: "Contacta con el comercial Contera para más información.",
    dahuaCameras: "Cámaras DAHUA",
    tvtCameras: "Cámaras TVT",
    totalCatalog: "Total catálogo",
    howToUse: "Cómo usar",
    step1: "Escribe parte de la referencia en el campo (mínimo 2 caracteres)",
    step2: "Selecciona el modelo correcto de la lista de sugerencias",
    step3: "Haz clic en",
    step3b: "para ver el equivalente de la otra marca",
    catalogTip: "También puedes usar el",
    catalogTipLink: "Catálogo",
    catalogTipEnd: "para filtrar y comparar cámaras lado a lado",

    // Footer
    footer: "© 2026 Contera — Comparador CCTV IP · DAHUA vs TVT",
    footerPrices: "Precios indicativos s/IVA · Contacto:",
  },
} as const;

export type TranslationKey = keyof typeof translations["pt"];
